import { useCallback } from 'react';
import { fileDownload } from '@/utils';
import { IFaqExportDTO } from '@/models/faqImportExport.model';
import { useAppDispatch, useAppState } from '@/store';
import { exportFaqs, selectIsExportingFaqs } from '../feature';

export const useExportFaqs = () => {
  const dispatch = useAppDispatch();
  const isExporting = useAppState(selectIsExportingFaqs);

  const handleExportFaqs = useCallback(
    async (params: IFaqExportDTO) => {
      try {
        const file = await dispatch(exportFaqs(params)).unwrap();
        fileDownload(file, 'text/csv', '_self');
      } catch {}
    },
    [dispatch],
  );

  return { handleExportFaqs, isExporting };
};
